// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kUVH","rootNoMargin":"styles_rootNoMargin__CZYKE"};